module.exports = __webpack_public_path__ + "img/01.7689dd85.svg";